<template>
  <reg-card>
    <p class="eyebrow">BEM-VINDO</p>
    <h2 class="title">Criar uma conta</h2>

    <div class="field">
      <label>Nome do grupo/restaurante</label>
      <input
        v-model="local.nome"
        class="inp"
        :class="{ err: erros.nome }"
        placeholder="Escreve aqui"
        @input="erros.nome = ''"
      />
      <p v-if="erros.nome" class="err-msg">{{ erros.nome }}</p>
    </div>

    <div class="field">
      <label>Email</label>
      <input
        v-model="local.email"
        class="inp"
        type="email"
        :class="{ err: erros.email }"
        placeholder="restaurante@restaurante.com"
        @input="erros.email = ''"
      />
      <p v-if="erros.email" class="err-msg">{{ erros.email }}</p>
    </div>

    <div class="field">
      <label>Password</label>
      <div class="inp-wrap">
        <input
          v-model="local.password"
          class="inp"
          :type="showPass ? 'text' : 'password'"
          :class="{ err: erros.password }"
          placeholder="••••••••••••"
          @input="erros.password = ''"
        />
        <button type="button" class="eye" @click="showPass = !showPass">
          <svg
            v-if="!showPass"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          <svg
            v-else
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
            />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        </button>
      </div>
      <p v-if="erros.password" class="err-msg">{{ erros.password }}</p>
    </div>

    <button class="btn-dark" :disabled="loading" @click="submit">
      <span v-if="loading" class="spinner"></span>
      <span v-else>COMEÇAR</span>
    </button>

    <div class="divider"><span>OU</span></div>

    <button class="btn-social" disabled>
      <svg width="18" height="18" viewBox="0 0 24 24">
        <path
          fill="#4285F4"
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        />
        <path
          fill="#FBBC05"
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"
        />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        />
      </svg>
      Criar conta com o Google
    </button>
    <button class="btn-social" disabled>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="#1877F2">
        <path
          d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
        />
      </svg>
      Criar conta com o Facebook
    </button>
    <button class="btn-social" disabled>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.54 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701z"
        />
      </svg>
      Criar conta com a Apple
    </button>

    <p class="footer-link">
      Já tem conta?
      <router-link to="/login"><strong>FAÇA LOGIN</strong></router-link>
    </p>
  </reg-card>
</template>

<script>
  import RegCard from "../components/RegCard.vue";
  import { registerService } from "../../../../services/register.service";

  export default {
    name: "RegStep1",
    components: { RegCard },
    props: {
      form: { type: Object, required: true },
    },
    data() {
      return {
        local: {
          nome: this.form.nome,
          email: this.form.email,
          password: this.form.password,
        },
        erros: { nome: "", email: "", password: "" },
        showPass: false,
        loading: false,
      };
    },
    methods: {
      async submit() {
        this.erros = { nome: "", email: "", password: "" };
        if (!this.local.nome.trim()) {
          this.erros.nome = "Nome é obrigatório.";
          return;
        }
        if (!this.local.email.trim()) {
          this.erros.email = "Email é obrigatório.";
          return;
        }
        if (!this.local.password || this.local.password.length < 6) {
          this.erros.password = "Password deve ter pelo menos 6 caracteres.";
          return;
        }

        this.loading = true;
        try {
          await registerService.registar(
            this.local.nome.trim(),
            this.local.email.trim().toLowerCase(),
            this.local.password,
          );
          this.$emit("done", {
            nome: this.local.nome,
            email: this.local.email.trim().toLowerCase(),
            password: this.local.password,
          });
        } catch (err) {
          const msg = err.response?.data?.error || "Erro ao criar conta.";
          if (msg.toLowerCase().includes("email")) this.erros.email = msg;
          else this.erros.nome = msg;
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .eyebrow {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.14em;
    color: #ff825d;
    text-transform: uppercase;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    &::before {
      content: "";
      display: block;
      width: 16px;
      height: 2px;
      background: #ff825d;
      border-radius: 1px;
    }
  }
  .title {
    font-size: 24px;
    font-weight: 800;
    color: #1a1210;
    margin-bottom: 22px;
    letter-spacing: -0.4px;
    line-height: 1.2;
  }
  .field {
    margin-bottom: 14px;
    label {
      display: block;
      font-size: 11.5px;
      font-weight: 700;
      color: #9a9390;
      margin-bottom: 6px;
      text-transform: uppercase;
      letter-spacing: 0.04em;
    }
  }
  .inp {
    width: 100%;
    height: 48px;
    border: 1.5px solid #ede9e5;
    border-radius: 11px;
    padding: 0 14px;
    font-size: 14px;
    color: #1a1210;
    outline: none;
    font-family: inherit;
    transition: all 0.15s;
    background: #fdfcfb;
    &:focus {
      border-color: #ff825d;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(255, 130, 93, 0.1);
    }
    &.err {
      border-color: #e53e3e;
      background: #fff8f8;
    }
    &::placeholder {
      color: #c8c0b8;
    }
  }
  .inp-wrap {
    position: relative;
    .inp {
      padding-right: 46px;
    }
  }
  .eye {
    position: absolute;
    right: 13px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #c0b8b0;
    padding: 4px;
    border-radius: 6px;
    &:hover {
      color: #7a736e;
      background: #f0ece8;
    }
  }
  .err-msg {
    font-size: 12px;
    color: #e53e3e;
    margin-top: 5px;
    font-weight: 500;
  }
  .btn-dark {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 12px;
    background: #1a1210;
    color: #fff;
    font-size: 13.5px;
    font-weight: 700;
    letter-spacing: 0.08em;
    cursor: pointer;
    font-family: inherit;
    margin-top: 22px;
    transition: all 0.15s;
    box-shadow: 0 4px 14px rgba(26, 18, 16, 0.25);
    &:hover:not(:disabled) {
      background: #2d2420;
      transform: translateY(-1px);
      box-shadow: 0 6px 20px rgba(26, 18, 16, 0.3);
    }
    &:active {
      transform: translateY(0);
    }
    &:disabled {
      opacity: 0.5;
      cursor: default;
      box-shadow: none;
      transform: none;
    }
  }
  .spinner {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  .divider {
    position: relative;
    text-align: center;
    margin: 20px 0 14px;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 1px;
      background: #f0ece8;
    }
    span {
      position: relative;
      background: #fff;
      padding: 0 14px;
      font-size: 11.5px;
      color: #c0b8b0;
      font-weight: 600;
      letter-spacing: 0.06em;
    }
  }
  .btn-social {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    height: 46px;
    border: 1.5px solid #ede9e5;
    border-radius: 11px;
    background: #fdfcfb;
    font-size: 13.5px;
    color: #5a534f;
    cursor: not-allowed;
    font-family: inherit;
    padding: 0 16px;
    margin-bottom: 8px;
    opacity: 0.55;
    transition: all 0.15s;
  }
  .footer-link {
    text-align: center;
    font-size: 13px;
    color: #b0a8a0;
    margin-top: 18px;
    a {
      color: #1a1210;
      text-decoration: none;
      font-weight: 700;
      letter-spacing: 0.02em;
      &:hover {
        color: #ff825d;
      }
    }
  }
</style>
